/** VGI / Alinea / Gamalytic 的 Steam Players by Country，仅支持 daily 粒度 */
export const STEAM_PLAYERS_BY_COUNTRY_METRICS = [
  'players_by_country',
  'gamalytic__players_by_country',
  'alinea__players_by_country',
] as const;

export type TSteamPlayersByCountryMetric =
  (typeof STEAM_PLAYERS_BY_COUNTRY_METRICS)[number];

export const STEAM_PLAYERS_BY_COUNTRY_DAILY_GRANULARITY = 'daily';

export const isSteamPlayersByCountryMetric = (
  metric?: string | null,
): metric is TSteamPlayersByCountryMetric => {
  if (!metric) return false;
  return (STEAM_PLAYERS_BY_COUNTRY_METRICS as readonly string[]).includes(metric);
};

const collectMetricsFromPayload = (payload: any): string[] => {
  const metrics: string[] = [];
  const push = (value: unknown) => {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (typeof item === 'string') {
          metrics.push(item);
        }
      });
      return;
    }
    if (typeof value === 'string') {
      metrics.push(value);
    }
  };

  push(payload?.metric);
  push(payload?.metrics);

  const sourceMetrics = payload?.source_metrics;
  if (sourceMetrics && typeof sourceMetrics === 'object') {
    Object.values(sourceMetrics).forEach(push);
  }

  return metrics;
};

export const payloadIncludesSteamPlayersByCountryMetric = (
  payload: any,
): boolean =>
  collectMetricsFromPayload(payload).some(isSteamPlayersByCountryMetric);

/** 将请求体中的粒度强制为 daily（仅当包含上述三类 players_by_country 指标时） */
export const forceDailyGranularityForPlayersByCountry = (payload: any): any => {
  if (!payloadIncludesSteamPlayersByCountryMetric(payload)) {
    return payload;
  }

  const result = { ...payload };
  result.granularity = STEAM_PLAYERS_BY_COUNTRY_DAILY_GRANULARITY;

  if ('period' in result) {
    result.period = STEAM_PLAYERS_BY_COUNTRY_DAILY_GRANULARITY;
  }
  if ('date_type' in result) {
    result.date_type = STEAM_PLAYERS_BY_COUNTRY_DAILY_GRANULARITY;
  }

  return result;
};

export const resolveSteamSalesPeriod = (
  metric: string,
  fallbackPeriod = 'monthly',
): string => {
  if (isSteamPlayersByCountryMetric(metric)) {
    return STEAM_PLAYERS_BY_COUNTRY_DAILY_GRANULARITY;
  }
  return fallbackPeriod;
};
